export default "__VITE_ASSET__1e69903c__"